import React from 'react';
import Modal from "components/Modal";
import FeedbackRegister from 'components/ModalFeedbackRegister/FeedbackRegister';
import { actionsType } from 'config/constants';

const ModalFeedbackRegister = () => {

    return (
        <Modal customClass='modal-feedback-register' actionOpen={actionsType.MODAL.FEEDBACK_REGISTER_OPEN} actionClose={actionsType.MODAL.FEEDBACK_REGISTER_CLOSE}>
            <FeedbackRegister />
        </Modal>
    );
}

export default ModalFeedbackRegister;
